import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPublicOrder } from '../api';

export default function OrderConfirmationPage() {
  const { businessId, orderId } = useParams();
  const navigate  = useNavigate();
  const [order,   setOrder]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNF]     = useState(false);

  useEffect(() => {
    getPublicOrder(businessId, orderId)
      .then(setOrder)
      .catch(() => setNF(true))
      .finally(() => setLoading(false));
  }, [businessId, orderId]);

  if (loading) return <div className="page"><div className="loading">Loading…</div></div>;

  if (notFound || !order) return (
    <div className="page">
      <div className="header"><h1>Order Not Found</h1></div>
      <div className="confirmation-page">
        <p style={{ color:'#888', marginBottom:20 }}>We couldn't find this order.</p>
        <button className="new-order-btn" onClick={() => navigate(`/shop/${businessId}`)}>
          Go to Menu
        </button>
      </div>
    </div>
  );

  return (
    <div className="page">
      <div className="header">
        <h1>Order Placed!</h1>
        <p>Show this screen to the vendor</p>
      </div>

      <div className="confirmation-page">
        {/* Big order ID */}
        <div className="order-id-badge">
          <div className="order-id-label">Your Order Number</div>
          <div className="order-id-number">#{order.id}</div>
        </div>

        {/* Instruction */}
        <div className="instruction-box">
          <div className="instruction-text">
            Pay via UPI / GPay and tell Order #{order.id} to the vendor
          </div>
        </div>

        {/* Items */}
        <div className="order-items-list">
          <div className="order-items-title">Your Items</div>
          {order.items.map((item, idx) => (
            <div key={idx} className="order-item-row">
              <span>{item.name} × {item.quantity}</span>
              <span>₹{item.price * item.quantity}</span>
            </div>
          ))}
          <div className="order-total-row">
            <span>Total</span>
            <span>₹{order.total_amount}</span>
          </div>
        </div>

        <button className="new-order-btn" onClick={() => navigate(`/shop/${businessId}`)}>
          + Place Another Order
        </button>
      </div>
    </div>
  );
}
